/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsWhatsIncluded = {
    init: function ($section) {
      const $sliderElement = $section.find('[data-mobile-text-slider]');

      let slider = $sliderElement.flickity({
        wrapAround: false,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: 'left',
      });

      let $blocks = $sliderElement.find('[data-index]')
      
      $section.on('click touchstart', '[data-thumb-image]', function (e) {        
        let index = $(this).data('index')
        slider.flickity('select', index);

        // Mobile Thumb Image
        $('.column.one-fifth').removeClass('is-active');
        $(this).addClass('is-active');
        
        // Mobile Preview Image
        $('.whats-mobile-img-item').removeClass('is-active');
        $('.whats-mobile-img-'+index).addClass('is-active');
      });
      setTimeout(function () {
        slider.flickity('resize');
      }, 500);

      slider.on('select.flickity', function(event, index) {        
        let CurrentSlide = index + 1;        
        $('.whats-section .column.one-fifth:nth-child('+CurrentSlide+')').addClass('is-active').siblings().removeClass('is-active');
        $('.whats-section').flickity('select', index);
        $('.whats-mobile-img-item').removeClass('is-active');
        $('.whats-mobile-img-'+index).addClass('is-active');
      });

    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;